const exposeStore = process.env.REACT_APP_EXPOSE_STORE === 'true';

export const setStoreToWindowObject = (key: string, target: any) => {
  if (exposeStore) {
    (window as any)[key] = target;
  }
};
